<template>
  <div class="summary" :class="{ 'summary--sheet': cartSheet }">
    <div class="summary-card">

      <div class="summary-top-row">
        <div class="summary-title evidence">
          {{ $t(getBet.type) }}
          <span v-if="getSettings.sm_multiplicity">({{ getBet._multiple_detail.multiplicity }})</span>
        </div>
        <div class="summary-odds-container" v-if="getSettings.sm_odds_total">
          <span class="odds-label">{{ $t('bets.odd') || 'Cuota total' }}</span>
          <span class="odds-value">{{ getBet._multiple_detail.odds_total | round_digits(2) | odds_type_filter }}</span>
        </div>
      </div>

      <div class="summary-bottom-row">

        <div class="amount-container">
<!--          <span class="input-label">{{ $t('amount') || 'Importe' }}</span>-->
          <div class="input-group">
            <button class="btn-stepper" @click="decreaseAmount">-</button>

            <input
                v-if="!isMobile"
                ref="amountInput"
                autocomplete="off"
                :value="displayAmount"
                type="text"
                inputmode="decimal"
                @focus="handleFocus"
                @blur="handleBlur"
                @input="handleInputDesktop"
                id="amount"
                class="amount-input"
            />
            <input
                v-else
                ref="amountInput"
                autocomplete="off"
                :readonly="useVirtualKeyboard"
                :inputmode="useVirtualKeyboard ? 'none' : 'decimal'"
                :value="displayAmount"
                :class="['amount-input', { 'text-selected': replaceMode }]"
                @focus="handleFocus($event)"
                @click="handleFocus($event)"
                @input="useVirtualKeyboard ? null : handleInputDesktop($event)"
                @blur="useVirtualKeyboard ? null : handleBlur()"
                id="amount"
            />

            <button class="btn-stepper" @click="increaseAmount">+</button>
          </div>
        </div>

        <div class="winning-container" v-if="getSettings.sm_winning">
          <span class="winning-label">{{ cartSheet ? $t('potentialWinnings') : ($t('winning') || 'Posible ganancia') }}</span>
          <div class="winning-value">
            {{ displayedWinning | round_digits(2) }}
            <span class="winning-currency">{{ getSettings.currencySymbol || 'USD' }}</span>
          </div>
        </div>
      </div>

      <div class="keyboard-accordion-wrapper" :class="{ 'keyboard-open': showCustomKeyboard && isMobile && useVirtualKeyboard }">
        <div
            v-if="isMobile"
            class="custom-keyboard-accordion"
            @mousedown.prevent
        >
          <div class="keyboard-row">
            <button v-for="n in [1,2,3, 4, 5, 6, 7, 8, 9]" :key="'kb1_'+n" @click="pressKey(n)">{{n}}</button>
            <button @click="pressKey(0)">0</button>
          </div>
          <div class="keyboard-row">
            <button @click="pressKey('.')">,</button>
            <button @click="backspace">⌫</button>
            <button class="close-keyboard" @click="showCustomKeyboard = false">{{ $t('close') }}</button>
          </div>
        </div>
      </div>

      <div class="container_btn_add_amount" v-if="getSettings.enableButtonsCart">
        <v-btn class="btn_add_amount_cart" px-1 py-1 v-for="(buttonCart,index) in getSettings.buttonsCart" :key="index" @click="addAmountBet(buttonCart.value)">
          +{{buttonCart.value}} {{getSettings.currencySymbol}}
        </v-btn>
      </div>

      <FreeBetsSelector></FreeBetsSelector>

      <div class="extra-info-container" ref="infoBet" v-if="hasExtraInfo">
        <div class="extra-info-row" v-if="showBonus && getSettings.sm_bonus && +getBet._multiple_detail.bonus_percentage > 0">
          <span class="info-label">{{$t('bonus')}}</span>
          <span class="info-value">% {{ getBet._multiple_detail.bonus_percentage }}</span>
        </div>
        <div class="extra-info-row" v-if="showBonus && getSettings.sm_bonus_total && +getBet._multiple_detail.bonus > 0">
          <span class="info-label">{{$t('bonus')}} {{$t('total')}}</span>
          <span class="info-value">{{ getSettings.currencySymbol }} {{ getBet._multiple_detail.bonus | round_digits(2) }}</span>
        </div>
        <div class="extra-info-row" v-if="getSettings.sm_profit">
          <span class="info-label">{{$t('profit')}}</span>
          <span class="info-value">{{ getSettings.currencySymbol }} {{ getBet._multiple_detail.profit | round_digits(2) }}</span>
        </div>
        <div class="extra-info-row" v-if="getSettings.sm_winning_total">
          <span class="info-label">{{$t('winning')}} {{$t('total')}}</span>
          <span class="info-value">{{ displayedWinningTotal | round_digits(2) }} {{ getSettings.currency }} </span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FreeBetsSelector from "@/components/right_widgets/FreeBetsSelector";

export default {
  name: "SummarySingleMultiple",
  components: { FreeBetsSelector },
  inject: { cartSheet: { default: false } },
  data: () => ({
    previousAmount: null,
    showCustomKeyboard: false,
    replaceMode: false,
    windowWidth: typeof window !== "undefined" ? window.innerWidth : 1024,
  }),
  mounted() {
    this.$root.$on("forceUpdateSingleMultiple", () => {
      this.forceUpdateSummaryMultiple();
    });
    window.addEventListener('resize', this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },
  computed: {
    ...mapGetters({
      getBet: "cart/getBet",
      getSettings: "cart/getSettings",
      getBonusRules: "cart/getBonusRules",
      getMobileKeypadType: "settings/getMobileKeypadType",
      getSelectedFreeBet: "cart/getSelectedFreeBet",
      getParentStakeLock: "cart/getParentStakeLock",
    }),
    isMobile() {
      return this.windowWidth <= 768;
    },
    useVirtualKeyboard() {
      return this.getMobileKeypadType !== 'native';
    },
    // Giocando con una freebet il bonus multipla non si applica: non va mostrato.
    showBonus() {
      return !this.getSelectedFreeBet;
    },
    // maxWin della freebet selezionata (null se non c'è freebet o non ha limite).
    freeBetMaxWin() {
      const freeBet = this.getSelectedFreeBet;
      if (!freeBet || freeBet.maxWin == null || freeBet.maxWin === '') return null;
      const maxWin = Number(freeBet.maxWin);
      return Number.isFinite(maxWin) ? maxWin : null;
    },
    // Con una freebet la vincita non supera il suo maxWin.
    displayedWinning() {
      const winning = Number(this.getBet._multiple_detail.winning) || 0;
      return this.freeBetMaxWin != null ? Math.min(winning, this.freeBetMaxWin) : winning;
    },
    // Vincita totale: con una freebet senza bonus e limitata al maxWin.
    displayedWinningTotal() {
      const detail = this.getBet._multiple_detail;
      const total = Number(detail.winning_total) || 0;
      if (this.showBonus) return total;
      const withoutBonus = total - (Number(detail.bonus) || 0);
      return this.freeBetMaxWin != null ? Math.min(withoutBonus, this.freeBetMaxWin) : withoutBonus;
    },
    hasExtraInfo() {
      // Controlla se almeno uno degli extra info è visibile per renderizzare il container
      return (this.showBonus && this.getSettings.sm_bonus && +this.getBet._multiple_detail.bonus_percentage > 0) ||
          (this.showBonus && this.getSettings.sm_bonus_total && +this.getBet._multiple_detail.bonus > 0) ||
          this.getSettings.sm_profit ||
          this.getSettings.sm_winning_total;
    },
    displayAmount() {
      let val = this.getBet._multiple_detail.amount;
      if (this.replaceMode && (!this.isMobile || !this.useVirtualKeyboard)) {
        return String(val).replace('.', ',');
      }
      return Number(val || 0).toFixed(2).replace('.', ',');
    }
  },
  watch: {
    showCustomKeyboard(val) {
      if (!val) {
        this.handleBlur();
        return;
      }
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.getElementById("modal_cart_content");
          if (!el) return;
          el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
        }, 150);
      });
    },
    // The embedding page set the stake: show the new amount (place bet waits meanwhile)
    getParentStakeLock(locked) {
      if (locked) this.pulseAmount();
    },
  },
  methods: {
    ...mapActions({
      refreshCart: "cart/refreshCart",
    }),
    handleFocus(e) {
      this.previousAmount = this.getBet._multiple_detail.amount;
      this.replaceMode = true;
      if (this.isMobile && this.useVirtualKeyboard) {
        this.showCustomKeyboard = true;
      }
      this.$nextTick(() => {
        if (e && e.target) e.target.select();
      });
    },
    handleInputDesktop(e) {
      let val = e.target.value;

      // Sostituisce virgole con punti e rimuove caratteri non validi
      val = val.replace(/,/g, '.').replace(/[^0-9.]/g, '');

      // Evita l'inserimento di multipli punti (es. 1.2.3)
      const parts = val.split('.');
      if (parts.length > 2) {
        val = parts[0] + '.' + parts.slice(1).join('');
      }

      // Limita la digitazione a 2 decimali
      if (val.includes('.') && val.split('.')[1].length > 2) {
        val = val.substring(0, val.indexOf('.') + 3);
      }

      // Store a Number, keeping the raw string only for the two states a number
      // cannot represent: an empty field, and a trailing separator mid-typing
      // ("1."). Same rule the custom keyboard below already applies, and
      // handleBlur normalises whatever is left of it.
      // Before this, every keystroke left a string in `amount`; that string
      // reached round_digits and threw TypeError during render.
      this.getBet._multiple_detail.amount = (val === '' || val.endsWith('.')) ? val : Number(val);
      this.verifyAmount(Number(val));
      this.refreshCart();
      this.vibrate();
    },

    handleBlur() {
      let amount = this.getBet._multiple_detail.amount;
      if (amount === null || amount === "" || amount === undefined) {
        amount = this.previousAmount;
      }
      const min = this.getSettings.minAmount || 0;
      if (Number(amount) < min) amount = min;

      this.getBet._multiple_detail.amount = Number(amount);
      this.refreshCart();

      this.showCustomKeyboard = false;
      this.replaceMode = false; // FONDAMENTALE: Riattiva la formattazione displayAmount disattivando il focus state
    },
    handleInput() {
      this.verifyAmount(this.getBet._multiple_detail.amount);
      this.refreshCart();
      this.vibrate();
    },
    decreaseAmount() {
      let current = Number(this.getBet._multiple_detail.amount) || 0;
      let min = this.getSettings.minAmount || 0;
      if (current > min) {
        this.getBet._multiple_detail.amount = parseFloat(Math.max(min, current - 1).toFixed(2));
        this.handleInput();
      }
    },
    increaseAmount() {
      let current = Number(this.getBet._multiple_detail.amount) || 0;
      this.getBet._multiple_detail.amount = parseFloat((current + 1).toFixed(2));
      this.handleInput();
    },
    vibrate() {
      if (navigator.vibrate) {
        navigator.vibrate(10);
      }
    },
    addAmountBet(amount) {
      if (amount != undefined && +amount > 0.0) {
        const a = Number(this.getBet._multiple_detail.amount) || 0;
        this.getBet._multiple_detail.amount = parseFloat((a + Number(amount)).toFixed(2));
        this.vibrate();
        this.pulseAmount();
        this.refreshCart();
      }
    },
    pulseAmount() {
      if (this.$refs.amountInput)
        this.$refs.amountInput.classList.add("pulse");
      setTimeout(() => {
        if (this.$refs.amountInput)
          this.$refs.amountInput.classList.remove("pulse");
      }, 200);
    },
    forceUpdateSummaryMultiple() {
      this.$forceUpdate();
    },
    async verifyAmount(amount) {
      if (amount < 0) {
        this.getBet._multiple_detail.amount = 0;
        await this.$store.dispatch("cart/refreshCart");
      }
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    pressKey(key) {
      let cur;
      if (this.replaceMode) {
        this.replaceMode = false;
        cur = "";
        if (key === 0) { this.getBet._multiple_detail.amount = 0; this.refreshCart(); this.vibrate(); return; }
      } else {
        cur = String(this.getBet._multiple_detail.amount || "");
      }
      if (cur === "" && key === 0) return;
      if (cur === "0" && key !== ".") cur = "";
      if (key === "." && cur.includes(".")) return;
      if (key === "." && cur === "") cur = "0";
      // Limita a max 2 decimali
      if(cur.includes(".") && cur.split(".")[1]?.length >= 2) {
        if(key === ".") return;
        if(cur.indexOf(".") !== -1 && cur.length-cur.indexOf(".") > 2) return;
      }
      cur += key;
      cur = cur.replace(/^0+([1-9])/, "$1");
      cur = cur.replace(/\.+/g, '.');
      if (cur.endsWith(".")) {
        this.getBet._multiple_detail.amount = cur;
      } else {
        this.getBet._multiple_detail.amount = Number(cur);
        this.verifyAmount(Number(cur));
      }
      this.refreshCart();
      this.vibrate();
    },
    backspace() {
      this.replaceMode = false;
      let cur = String(this.getBet._multiple_detail.amount || "");
      cur = cur.slice(0, -1);
      if (cur === "" || cur === "0") {
        this.getBet._multiple_detail.amount = 0;
      } else if(cur.endsWith(".")) {
        this.getBet._multiple_detail.amount = cur;
      } else {
        this.getBet._multiple_detail.amount = Number(cur);
      }
      this.refreshCart();
    },
  }
};
</script>

<style scoped>
.summary {
  padding: 0 0 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.summary-card {
  background: var(--bg-card); /* Sfondo scuro della card */
  border-radius: 8px;
  padding: 14px;
}

/* --- Riga Superiore (Titolo e Quota) --- */
.summary-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.summary-title {
  color: var(--text-platform);
  font-weight: 700;
  font-size: var(--font-size-5xl);
  text-transform: capitalize;
}

.summary-odds-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.odds-label {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-2xl);
  text-transform: capitalize;
}

.odds-value {
  color: var(--color-primary-light); /* Verde acceso */
  font-weight: 700;
  font-size: var(--font-size-6xl);
}

/* --- Riga Inferiore (Input e Vincita) --- */
.summary-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

/* Contenitore Input */
.amount-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.input-label {
  color: var(--text-platform);
  font-size: var(--font-size-xl);
}

.input-group {
  display: flex;
  background: var(--sidebar); /* Sfondo scuro dell'input */
  overflow: hidden;
  width: 100%; /* Larghezza controllata per lo spazio desktop/mobile */
  gap: 4px;
  padding: 10px ;
  border-radius: 8px;
}

.btn-stepper {
  background: var(--bg-card);
  color: var(--text-platform);
  height: 36px;
  width: 36px;
  font-size: var(--font-size-7xl);
  cursor: pointer;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;

}

.btn-stepper:hover {
  background: rgba(255, 255, 255, 0.05);
}

.btn-stepper:active {
  background: rgba(255, 255, 255, 0.1);
}

.amount-input {
  flex: 1;
  width: 100%;
  background: var(--bg-card);
  border: none;
  color: var(--text-platform);
  font-size: var(--font-size-4xl);
  font-weight: 600;
  text-align: center;
  outline: none;
  -moz-appearance: textfield;
  border-radius: 6px;

}

.amount-input::-webkit-outer-spin-button,
.amount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}



.pulse {
  animation: amountPulse 0.25s ease;
}
@keyframes amountPulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.04); }
  100% { transform: scale(1); }
}

/* Contenitore Vincita */
.winning-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.winning-label {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-xl);
}

.winning-value {
  color: var(--color-primary-light); /* Verde acceso */
  font-weight: 700;
  font-size: var(--font-size-6xl);
  display: flex;
  align-items: center;
  gap: 4px;
  height: 36px; /* Mantiene l'allineamento con l'input */
}

.winning-currency {
  font-size: var(--font-size-2xl);
  font-weight: 700;
}


/* --- Tastierino Mobile (Invariato nella logica, adattato al tema) --- */
.keyboard-accordion-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  transition: grid-template-rows 0.1s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease;
}
.keyboard-accordion-wrapper.keyboard-open {
  grid-template-rows: 1fr;
  opacity: 1;
}
.custom-keyboard-accordion {
  overflow: hidden;
  margin-top: 0;
  padding: 0 6px;
  background: var(--bg-card);
  border-radius: 8px;
  user-select: none;
  touch-action: none;
  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.keyboard-accordion-wrapper.keyboard-open .custom-keyboard-accordion {
  padding: 10px 0 0;
  margin-top: 12px;
}
.keyboard-row {
  display: flex;
  justify-content: space-between;
  gap: 4px;
  margin: 6px 0;
}
.keyboard-row button {
  flex: 1;
  padding: 8px 0;
  font-size: var(--font-size-7xl);
  background: var(--sidebar);
  border: none;
  border-radius: 6px;
  font-weight: 600;
  color: var(--text-platform);
  outline: none;
  transition: background 0.15s;
}
.keyboard-row button:active {
  background: #3c4652;
}
.close-keyboard {
  width: 100%;
  padding: 12px 0;
  background: #ef4444 !important;
  color: #fff;
  font-weight: bold;
  border-radius: 6px;
  font-size: var(--font-size-4xl);
}


/* --- Elementi Opzionali --- */
.container_btn_add_amount {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}
.btn_add_amount_cart {
  flex: 1 !important;
  background: var(--sidebar) !important;
  color: var(--text-platform) !important;
  font-size: var(--font-size-xl) !important;
  height: 36px !important;
  border-radius: 5px !important;
  font-weight: bolder !important;
  transition: all 0.15s ease !important;
}
.btn_add_amount_cart:hover {
  background: var(--sidebar) !important;
  color: #ffffff !important;
}

.extra-info-container {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.extra-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-label {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-2xl);
}
.info-value {
  color: var(--color-primary-light);
  font-weight: 600;
  font-size: var(--font-size-3xl);
}

/* ── Bottom sheet mobile: importo a tutta larghezza, vincita sotto ── */
.summary--sheet .summary-card {
  border-radius: 12px;
  padding: 16px;
  border: 1px solid var(--border-color, rgba(255,255,255,0.06));
}

.summary--sheet .summary-top-row {
  margin-bottom: 14px;
}

.summary--sheet .summary-bottom-row {
  flex-direction: column;
  gap: 16px;
}

.summary--sheet .input-group {
  padding: 4px;
  border-radius: 12px;
  border: 1px solid var(--border-color, rgba(255,255,255,0.06));
}

.summary--sheet .btn-stepper {
  width: 44px;
  height: 38px;
  border-radius: 10px;
}

.summary--sheet .btn-stepper:active {
  transform: scale(0.94);
}

.summary--sheet .amount-input {
  height: 38px;
  font-size: var(--font-size-4xl);
  font-weight: 700;
  background: transparent;
}

.summary--sheet .winning-container {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 4px;
}

.summary--sheet .winning-label {
  font-size: var(--font-size-2xl);
}

.summary--sheet .winning-value {
  height: auto;
}

.summary--sheet .btn_add_amount_cart {
  height: 34px !important;
  border-radius: 10px !important;
}
</style>